import Button from "../../../Button";
import React, { ReactNode, useState } from "react";
import CustomerAuthModal from "./CustomerAuthModal";
import OtpModal from "../../OtpModal";

interface IProps {
  btnName?: string | ReactNode;
  btnClassName?: string;
}

const CustomerAuth: React.FC<IProps> = ({
  btnName = "Login",
  btnClassName = "",
}) => {
  const [authModal, setAuthModal] = useState<boolean>(false);
  const [otpModal, setOtpModal] = useState<boolean>(false);
  const [contactNumber, setContactNumber] = useState<string>("");

  const handleModalAuthOpen = () => {
    setAuthModal(true);
  };

  const handleModalAuthClose = () => {
    setAuthModal(false);
  };

  return (
    <>
      <div id="recaptcha-container"></div>
      <Button
        type="button"
        className={btnClassName}
        onClick={handleModalAuthOpen}
      >
        {btnName}
      </Button>
      {authModal && (
        <CustomerAuthModal
          modalShow={authModal}
          closeModal={handleModalAuthClose}
          setOtpModal={setOtpModal}
          setContactNumber={setContactNumber}
        />
      )}

      <OtpModal
        showModal={otpModal}
        closeModal={() => setOtpModal(false)}
        contactNumber={contactNumber}
      />
    </>
  );
};

export default CustomerAuth;
